import React, { useContext, useState, useEffect } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Context from '../../context/context';

function NumOfPayment() {
  const { state, dispatch } = useContext(Context);

  const setPrice = (data) => dispatch({ type: 'SET_PRICE_PERCENT', payload: data });
  const setPriceBack = (data) => dispatch({ type: 'SET_PRICE_BACK_PERCENT', payload: data });
  const setMaxPayments = (data) => dispatch({ type: 'SET_MAX_PAYMENTS', payload: data });
  const setMinPayments = (data) => dispatch({ type: 'SET_MIN_PAYMENTS', payload: data });

  const [numOfPayment, setNumOfPayment] = useState(1);
  const [creditCard, setCreditCard] = useState(1);

  const getDefaultNumForCard = (cardValue) => {
    if (cardValue === 1) return 1;     
    if (cardValue === 2) return 4.5;   
    if (cardValue === 4) return 5;     
    return 5;                         
  };

  const applyNumOfPayment = (selectedNum) => {
    const percentage = parseFloat(selectedNum);
    const percentageValue = (state.price * percentage) / 100;
    const percentageValueBack = (state.priceBack * percentage) / 100;

    state.pricePrecent = state.price + percentageValue;
    setPrice(state.pricePrecent);

    state.priceBackPercent = state.priceBack + percentageValueBack;
    setPriceBack(state.priceBackPercent);

    if (selectedNum === 1) {
      if (state.selectedOrbitBack) {
        const priceBackAmount = 0 * state.amount; 
        state.priceBack = state.priceBack - priceBackAmount;
        state.price = state.price - priceBackAmount;
      }
      const p1 = (state.price * 1) / 100;
      state.pricePrecent = state.price + p1;
      setPrice(state.pricePrecent);

      const p1b = (state.priceBack * 1) / 100;
      state.priceBackPercent = state.priceBack + p1b;
      setPriceBack(state.priceBackPercent);
    }

    if (selectedNum === 1) {
      setMaxPayments(1);
      setMinPayments(1);
    } else if (selectedNum === 4) {
      setMaxPayments(6);
      setMinPayments(2);
    } else if (selectedNum === 5) {
      setMaxPayments(9);
      setMinPayments(7);
    } else if (selectedNum === 6) {
      setMaxPayments(12);
      setMinPayments(10);
    } else if (selectedNum === 4.5) {
      setMaxPayments(1);
      setMinPayments(1);
    } else if (selectedNum === 5.5) {
      setMaxPayments(6);
      setMinPayments(4);
    } else if (selectedNum === 7) {
      setMaxPayments(12);
      setMinPayments(10);
    } else {
      setMaxPayments(1);
      setMinPayments(1);
    }
  };

  useEffect(() => {
    const initial = getDefaultNumForCard(creditCard);
    setNumOfPayment(initial);
    applyNumOfPayment(initial);
  }, []);

  const handleChangeNumOfPayment = (event) => {
    const selectedNum = event.target.value;
    setNumOfPayment(selectedNum);
    applyNumOfPayment(selectedNum);
    console.log('numOfPayment changed ->', selectedNum, state);
  };

  const handleChangeCreditCard = (event) => {
    const cardValue = event.target.value;
    setCreditCard(cardValue);

    const firstOption = getDefaultNumForCard(cardValue);
    setNumOfPayment(firstOption);
    applyNumOfPayment(firstOption);

    console.log('creditCard changed ->', cardValue, 'default numOfPayment ->', firstOption);
  };

  return (
    <div>
      <p style={{ fontWeight: 'bold', textAlign: 'center' }}>בחר סוג כרטיס אשראי</p>
      <Select
        labelId="cc-select-label"
        id="cc-select"
        value={creditCard}
        onChange={handleChangeCreditCard}
        label="מסלול"
        autoWidth
        className="dateInput"
        style={{ width: '300px' }}
      >
        <MenuItem value={1}>רגיל  (מומלץ לשלם ב ₪)</MenuItem>
        <MenuItem value={3}>אמריקן אקספרס (מומלץ לשלם ב ₪)</MenuItem>
        <MenuItem value={4}>חו"ל אמריקן אקספרס  (מומלץ לשלם ב $)</MenuItem>
        <MenuItem value={2}>חו"ל רגיל  (מומלץ לשלם ב $)</MenuItem>
      </Select>

      <p style={{ fontWeight: 'bold', textAlign: 'center' }}>בחר מספר תשלומים</p>

      {creditCard === 1 ? (
        <Select
          labelId="payments-select-label-1"
          id="payments-select-1"
          value={numOfPayment}
          onChange={handleChangeNumOfPayment}
          label="תשלומים"
          autoWidth
          className="dateInput"
          style={{ width: '300px' }}
        >
          <MenuItem value={1}>1</MenuItem>
          <MenuItem value={4}>2-6</MenuItem>
          <MenuItem value={5}>7-9</MenuItem>
          <MenuItem value={6}>10-12</MenuItem>
        </Select>
      ) : creditCard === 2 ? (
        <Select
          labelId="payments-select-label-2"
          id="payments-select-2"
          value={numOfPayment}
          onChange={handleChangeNumOfPayment}
          label="תשלומים"
          autoWidth
          className="dateInput"
          style={{ width: '300px' }}
        >
          <MenuItem value={4.5}>1</MenuItem>
        </Select>
      ) : creditCard === 4 ? (
        <Select
          labelId="payments-select-label-4"
          id="payments-select-4"
          value={numOfPayment}
          onChange={handleChangeNumOfPayment}
          label="תשלומים"
          autoWidth
          className="dateInput"
          style={{ width: '300px' }}
        >
          <MenuItem value={5}>1</MenuItem>
        </Select>
      ) : (
        <Select
          labelId="payments-select-label-3"
          id="payments-select-3"
          value={numOfPayment}
          onChange={handleChangeNumOfPayment}
          label="תשלומים"
          autoWidth
          className="dateInput"
          style={{ width: '300px' }}
        >
          <MenuItem value={5}>1-3</MenuItem>
          <MenuItem value={5.5}>4-6</MenuItem>
          <MenuItem value={6}>7-9</MenuItem>
          <MenuItem value={7}>10-12</MenuItem>
        </Select>
      )}
    </div>
  );
}

export default NumOfPayment;
